import { Component, OnInit, TemplateRef } from '@angular/core';
import { LayoutService } from 'app/services/common/layout.service';
import { PopoverContent, PopoverReference } from './popover-ref';
import {animate, state, style, transition, trigger} from '@angular/animations';

export const drawerAnimation = trigger('drawerAnimation', [
  state('void', style({transform: 'translateX(100%)'})),
  transition(':enter, :leave', [
    animate('0.3s ease-in-out', style({transform: 'translateX(0)'})),
  ]),
]);

@Component({
  templateUrl: './popover.component.html',
  styleUrls: ['./popover.component.scss'],
  animations: [drawerAnimation]
})
export class PopoverComponent implements OnInit {
  renderMethod: 'template' | 'component' | 'text' = 'component';
  title: string;
  hasCloseButton: boolean;
  className: string;
  content: PopoverContent;
  context: any;

  constructor(
    private popoverReference: PopoverReference,
    public layoutService: LayoutService
  ) { }

  ngOnInit() {
    this.title = this.popoverReference.title;
    this.hasCloseButton = this.popoverReference.hasCloseButton;
    this.className = this.popoverReference.className;
    if (!this.className) {
      this.className = 'mat-elevation-z5';
    }
    if (this.layoutService.screen.xs) {
      this.className += ' popover';
    } else if (this.layoutService.screen.md) {
      this.className += ' popover-right';
    } else if (this.layoutService.screen.lg) {
      this.className += ' popover-docked';
    }

    this.content = this.popoverReference.content;
    if (typeof this.content === 'string') {
      this.renderMethod = 'text';
    }
    if (this.content instanceof TemplateRef) {
      this.renderMethod = 'template';
      this.context = {
        close: this.popoverReference.close.bind(this.popoverReference),
        data: this.popoverReference.data
      }
    }
  }

  onCloseClick() {
    this.popoverReference.close();
  }
}
